module.exports = __webpack_public_path__ + "static/media/state-of-the-brew-1-banner.fa26a426.webp";